import React from 'react';
import { Loader2 } from 'lucide-react';

const EditPropertyModal = ({
  node,
  editValue,
  onValueChange,
  onSave,
  onClose,
  saving,
}) => {
  if (!node) return null;

  // Don't show edit modal for non-editable nodes
  if (!node.type) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-[#1A1B1E] border border-[#37383F] rounded-lg shadow-xl p-6 max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-xl font-bold text-white mb-4">Edit Property</h3>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-300 mb-2">
            {node.name}
          </label>
          <p className="text-xs text-gray-400 mb-3">{node.path}</p>

          {node.type === 'boolean' && (
            <div className="flex items-center gap-3">
              <button
                onClick={() => onValueChange(true)}
                className={`px-4 py-2 rounded-lg font-medium transition ${
                  editValue
                    ? 'bg-[#4CAF50] text-white'
                    : 'bg-[#2B2C2F] text-gray-300 border border-[#37383F]'
                }`}
              >
                True
              </button>
              <button
                onClick={() => onValueChange(false)}
                className={`px-4 py-2 rounded-lg font-medium transition ${
                  !editValue
                    ? 'bg-[#EE2B2A] text-white'
                    : 'bg-[#2B2C2F] text-gray-300 border border-[#37383F]'
                }`}
              >
                False
              </button>
            </div>
          )}

          {node.type === 'number' && (
            <div>
              <input
                type="number"
                value={editValue}
                onChange={(e) =>
                  onValueChange(Number.parseFloat(e.target.value))
                }
                min={node.min}
                max={node.max}
                step="0.1"
                className="w-full px-3 py-2 bg-[#131418] border border-[#37383F] rounded-lg focus:ring-2 focus:ring-[#EE2B2A] focus:border-transparent text-white"
              />
              {node.min !== undefined && (
                <p className="text-xs text-gray-400 mt-1">
                  Range: {node.min} - {node.max}
                </p>
              )}
            </div>
          )}

          {node.type === 'enum' && (
            <select
              value={editValue}
              onChange={(e) => onValueChange(e.target.value)}
              className="w-full px-3 py-2 bg-[#131418] border border-[#37383F] rounded-lg focus:ring-2 focus:ring-[#EE2B2A] focus:border-transparent text-white"
            >
              {node.options.map((option) => (
                <option key={option} value={option} className="bg-[#131418]">
                  {option}
                </option>
              ))}
            </select>
          )}

          {node.type === 'color' && (
            <div className="flex gap-3 items-center">
              <input
                type="color"
                value={editValue}
                onChange={(e) => onValueChange(e.target.value)}
                className="h-12 w-20 rounded cursor-pointer"
              />
              <input
                type="text"
                value={editValue}
                onChange={(e) => onValueChange(e.target.value)}
                className="flex-1 px-3 py-2 bg-[#131418] border border-[#37383F] rounded-lg focus:ring-2 focus:ring-[#EE2B2A] focus:border-transparent text-white"
              />
            </div>
          )}

          {node.type === 'text' && (
            <input
              type="text"
              value={editValue}
              onChange={(e) => onValueChange(e.target.value)}
              className="w-full px-3 py-2 bg-[#131418] border border-[#37383F] rounded-lg focus:ring-2 focus:ring-[#EE2B2A] focus:border-transparent text-white"
            />
          )}
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            disabled={saving}
            className="px-4 py-2 text-gray-300 bg-[#2B2C2F] border border-[#37383F] rounded-lg hover:bg-[#37383F] transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            disabled={saving}
            className="px-4 py-2 text-white bg-[#EE2B2A] rounded-lg hover:bg-[#d02524] transition disabled:opacity-50 flex items-center gap-2"
          >
            {saving && <Loader2 className="w-4 h-4 animate-spin" />}
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPropertyModal;
